module.exports = __webpack_public_path__ + "img/index19.4cede54a.png";